import { PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';

/**
 * 勤務 (shift_truck) ごとに「今その勤務が持っている案件 ID」を集める。
 *
 * 車両で束ねないのは、1 台に複数のドライバーが同じ時間帯で乗る勤務があるため。
 * 片方の勤務に案件が入っただけで、同じ車両に並ぶ別の人の行まで光ってしまう。
 * 回転 (cycle) は delivery の中の概念なので、回転が増えても delivery は分かれない。
 */
export function buildAssignedOrderIdsByShiftTruck(
  deliveries: readonly PlanningsDeliveryWithLegRunEntity[],
): Map<number, Set<number>> {
  const byShiftTruck = new Map<number, Set<number>>();

  deliveries.forEach((delivery) => {
    const orderIds = byShiftTruck.get(delivery.id) ?? new Set<number>();
    delivery.shipmentOrderLegRuns.forEach((legRun) => {
      orderIds.add(legRun.shipment_order_id);
    });
    byShiftTruck.set(delivery.id, orderIds);
  });

  return byShiftTruck;
}
